import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ff83477"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "用于管理系统的功能菜单", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  const _component_bind_role = _resolveComponent("bind-role");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.uac.permission.list,
    columns: $data.columns,
    showPagination: false,
    showRowIndex: false,
    rowKey: "permissionId",
    selectionEnable: false,
    topButtons: $data.topButtons,
    linkButtons: $data.linkButtons,
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["fetchApi", "columns", "topButtons", "linkButtons"]), _createVNode(_component_el_dialog, {
    modelValue: $data.bindRoleDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.bindRoleDialog = $event),
    title: "绑定角色",
    "destroy-on-close": "",
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [_createVNode(_component_bind_role, {
      permission: $data.currentPermission,
      onOnClose: _cache[0] || (_cache[0] = $event => $data.bindRoleDialog = false),
      onOnSubmit: $options.bindRole
    }, null, 8, ["permission", "onOnSubmit"])]),
    _: 1
  }, 8, ["modelValue"])]);
}